module.exports = __webpack_public_path__ + "static/media/spring.257f90e0.png";